// extracted by mini-css-extract-plugin
export var Header = "header-module--Header--1EE_5";
export var Title = "header-module--Title--3mN2e";
export var Nav = "header-module--Nav--3oFFV";
export var NavMenu = "header-module--NavMenu--1tuOb";